import React from "react";
import {citationLabel, isWebUrl} from "./citations";

// PLEX-6049: the sources behind a reply's [n] footnote markers (see citations.js), one
// numbered entry per Bedrock citation. A web source links out; a document citation points
// into the user's own file, so it is text only.
const CitationList = ({citations, className, testId}) => {
  if (!citations || citations.length === 0) return null;
  return (
    <ol className={className} data-testid={testId}>
      {citations.map((c, i) => {
        const label = citationLabel(c);
        return (
          <li key={i}>
            {isWebUrl(c.source) ? <a href={c.source} target="_blank" rel="noopener noreferrer">{label}</a> : label}
          </li>
        );
      })}
    </ol>
  );
};

export default CitationList;
